export default {
  name: 'Widok siatki',
  buttons: [
    {
      title: 'Pokaż/Ukryj siatkę'
    }
  ]
}